import Repository from "./Repository";

const GET_WAITLISTED = "/user/waitlisted";
const SEARCH_USERS = "/user/search-user"; // Use the main search endpoint
const ACTIVATE_USER = "/user/waitlisted";
const DELETE_USER = "/user/waitlisted";

export default {
  getWaitlistedUsers(page, limit) {
    return Repository.get(`${GET_WAITLISTED}?page=${page}&limit=${limit}`);
  },
  searchWaitlistedUsers(query, page) {
    const requestBody = {
      text: query,
    };
    // Use main search endpoint and we'll filter for service providers in the action
    return Repository.post(`${SEARCH_USERS}?page=${page}&limit=10`, requestBody);
  },
  filterWaitlistedUsers(statusFilter, page) {
    // Map statusFilter to waitlisted boolean
    let url = `${GET_WAITLISTED}?page=${page}&limit=10`;
    
    if (statusFilter === "waitlisted") {
      url += `&waitlisted=true`;
    } else if (statusFilter === "active") {
      url += `&waitlisted=false`;
    }
    
    return Repository.get(url);
  },
  activateWaitlistedUser(id) {
    return Repository.put(`${ACTIVATE_USER}/${id}/activate`);
  },
  deleteWaitlistedUser(id) {
    return Repository.delete(`${DELETE_USER}/${id}`);
  },
};
